export default __webpack_public_path__ + "static/media/information--end-of-advisory-maximum-speed-limit-90--g1.84ad37e8.png";